<template>
  <form @submit.prevent="submitForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Submit Feedback
        </p>
      </header>
      <section class="modal-card-body">
        <p class="mb-5">
          If you have a technical issue, question, or overall comment, please submit it below and we'll get back to you as quickly as we can.
        </p>

        <d-field label="Feedback*">
          <vue-editor v-model="feedbackForm.content" :required="true" :editor-toolbar="customToolbar" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Send
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';

  export default {
    data: () => ({
      saving: false,
      feedbackForm: {
        content: '',
      },
      customToolbar: [
        [{ header: [false, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['blockquote', 'code-block'],
        [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['clean'],
      ],
    }),
    methods: {
      async submitForm() {
        this.saving = true;
        try {
          await axios.post('/api/feedback', this.feedbackForm);
          this.$toast.open({ message: 'Thank you, your feedback has been submitted!', color: 'green-500', duration: 6000 });
          this.$parent.close();
        } catch (error) {
          this.$toast.open({ message: error.response, color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>